/**
 * Created by Andrey Popov on 9/23/25.
 */

const EditorMap2dSelection = function (map) {
    this.map = map;
    this.selectedUnits = [];
};

EditorMap2dSelection.prototype.hasSelectedUnits = function () {
    return this.selectedUnits.length > 0;
};

EditorMap2dSelection.prototype.getSelectedUnits = function () {
    return this.selectedUnits;
};

EditorMap2dSelection.prototype.isSelected = function (unit) {
    return this.selectedUnits.includes(unit);
};

EditorMap2dSelection.prototype.selectByDblClick = function (clickedUnit, isCtrlPressed) {
    if (clickedUnit.isMultiCellBody()) {
        clickedUnit = clickedUnit.head;
    }
    const region = Object.values(this.map.regions).find((r) => r.positions.some((p) => p.x === clickedUnit.x && p.y === clickedUnit.y));
    const regionPositions = region ? region.positions : [];
    const regionUnits = this.map.listAvailableUnits().filter((unit) => !unit.isMultiCellBody() && regionPositions.some((p) => p.x === unit.x && p.y === unit.y));

    const isUnitSelected = this.selectedUnits.includes(clickedUnit);
    const isRegionSelected = regionUnits.length > 0 && regionUnits.every((u) => this.selectedUnits.includes(u));

    this.selectedUnits.forEach((u) => {
        u.unhighlight();
    });

    if (isCtrlPressed) {
        if (!isUnitSelected) {
            this.selectedUnits.push(clickedUnit);
        } else {
            const idx = this.selectedUnits.indexOf(clickedUnit);
            if (idx >= 0) {
                this.selectedUnits.splice(idx, 1);
            }
        }
    } else if (!isUnitSelected) {
        this.selectedUnits = [clickedUnit];
    } else if (!isRegionSelected) {
        this.selectedUnits = [...regionUnits];
    } else {
        this.selectedUnits = [];
    }

    this.selectedUnits.forEach((u) => {
        u.highlight();
    });
};

EditorMap2dSelection.prototype.selectAllUnits = function () {
    if (this.selectedUnits.length > 0) {
        this.selectedUnits.forEach((u) => {
            u.unhighlight();
        });
        this.selectedUnits = [];
    } else {
        this.selectedUnits = this.map.listAvailableUnits().filter((unit) => !unit.isMultiCellBody());
        this.selectedUnits.forEach((u) => {
            u.highlight();
        });
    }
};

EditorMap2dSelection.prototype.clearSelection = function () {
    this.selectedUnits.forEach((u) => {
        u.unhighlight();
    });
    this.selectedUnits = [];
};

EditorMap2dSelection.prototype.selectUnitsInArea = function (cell1, cell2, isCtrlPressed) {
    if (!isCtrlPressed) {
        this.clearSelection();
    }
    for (let x = Math.min(cell1.x, cell2.x); x <= Math.max(cell1.x, cell2.x); x++) {
        for (let y = Math.min(cell1.y, cell2.y); y <= Math.max(cell1.y, cell2.y); y++) {
            let unit = this.map.getUnit(x, y);
            if (unit && unit.isMultiCellBody()) {
                unit = unit.head;
            }
            if (unit && !this.selectedUnits.includes(unit)) {
                this.selectedUnits.push(unit);
                unit.highlight();
            }
        }
    }
};

EditorMap2dSelection.prototype.iterate = function (mainUnit, action) {
    if (this.selectedUnits.includes(mainUnit)) {
        this.selectedUnits.forEach((unit) => {
            if (unit !== mainUnit && unit.onGetView()) {
                action(unit, unit.onGetView());
            }
        });
    }
};

EditorMap2dSelection.prototype.checkErrors = function (mainUnit) {
    let hasErrors = false;
    if (this.selectedUnits.includes(mainUnit)) {
        this.selectedUnits.forEach((unit) => {
            if (unit.light && unit.light.error) {
                hasErrors = true;
            }
        });
    }
    if (hasErrors) {
        this.selectedUnits.forEach((unit) => {
            if (unit.light) {
                unit.light.error = true;
            }
        });
    }
};